import cls from "./GameLobbyPlayerCard.module.scss";

export default function GameLobbyPlayerCard({ player }) {
  const avatarSrc = player?.image?.url || "";
  const playerInitial = (player?.displayName || "?").slice(0, 1).toUpperCase();
  const isPartnered = player?.partnerStatus === "partnered";
  const isActive = Boolean(player?.isActive);

  return (
    <article className={cls.card}>
      <div className={cls.cardGlow} />
      <div className={cls.topRow}>
        <span className={cls.playerNo}>#{player?.playerNo || "--"}</span>
        <span
          className={`${cls.statusBadge} ${
            isPartnered ? cls.partnered : cls.single
          }`}
        >
          {isPartnered ? "Paired" : "Single"}
        </span>
      </div>

      <div className={cls.avatarWrap}>
        {avatarSrc ? (
          <img
            src={avatarSrc}
            alt={player?.displayName || "Player avatar"}
            className={cls.avatar}
          />
        ) : (
          <div className={cls.avatarFallback}>{playerInitial}</div>
        )}
      </div>

      <div className={cls.info}>
        <h3 className={cls.name}>{player?.displayName || "Unknown Player"}</h3>

        <div className={cls.metaGrid}>
          <div className={cls.metaTile}>
            <span className={cls.metaLabel}>Clothes</span>
            <strong className={cls.metaValue}>
              {player?.currentCoins ?? "--"}
            </strong>
          </div>

          <div className={cls.metaTile}>
            <span className={cls.metaLabel}>Status</span>
            <strong className={cls.metaValue}>
              {isActive ? "Online" : "Away"}
            </strong>
          </div>
        </div>
      </div>
    </article>
  );
}
